import {
	ChildOnlyOption,
	CurrentIdentity,
	getMasterComponents,
	IChildrenProps,
	useComponentExtension,
	useExtensionPage,
	useExtensions,
	useIdentity,
	useTitle
} from 'fox-extensions';
import * as React from 'react';
import { Suspense } from 'react';
import { Route, Switch, useParams, Redirect } from 'react-router-dom';

// todo replace this with a proper error boundary
const ErrorBoundary = React.Fragment;

function CorePage() {
	const { authorized } = useIdentity();
	const { page, id } = useParams<{ page?: string; id?: string }>();

	const { PageComponent, anonymous, childOnly, title } = useExtensionPage(page);
	useTitle(title);

	if (!authorized && anonymous !== true) return <Unauthorized />;

	if (childOnly && childOnly === ChildOnlyOption.RedirectToRoot && !id) {
		return <Redirect to={`/`} />;
	}
	// todo provide a better fallback than null
	return (
		<Suspense fallback={null}>
			<ErrorBoundary>
				<PageComponent />
			</ErrorBoundary>
		</Suspense>
	);
}

// // function SafeRoute({ path, children }: { path: string } & IChildrenProps) {
// // 	return <Route path={path} render={() => <ErrorBoundary>{children}</ErrorBoundary>} />;
// // }

function Unauthorized() {
	if (CurrentIdentity.redirect_url) {
		return <h1>Authenticating...</h1>;
	}
	const UnauthPage = useComponentExtension('unauthorized-page', true);
	if (UnauthPage) return <UnauthPage />;

	return <h1>Unauthorized</h1>;
}

export function Routing() {
	// const { authorized } = useIdentity();

	const customRoutes = useExtensions<JSX.Element>('custom-routes');

	// if (!authorized) return <Unauthorized />;

	/**
	 * IMPORTANT!!!!!! READ THIS!!!!
	 *
	 * Refresh token will cause any page within to fully re-render (unmount/re-mount)
	 *
	 * If you want to prevent this (especially if the re-render is completely pointless and your page component
	 * doesn't take any top-level props), make sure your page component is wrapped with React.memo()
	 */
	return (
		<Suspense fallback={<div />}>
			<Switch>
				{customRoutes}
				<Route path="/:page/:id">
					<HostApp />
				</Route>
				<Route path="/:page/">
					<HostApp />
				</Route>
				<Route path="/">
					<HostApp />
				</Route>
			</Switch>
		</Suspense>
	);
}

export default function HostApp() {
	const masters = getMasterComponents();

	// note this is very fragile. If HostApp re-renders it will crash the whole UI.
	// My working theory is the identity of TopMaster changes, since it is inline, and it will cause it to unmount upon re-render.

	// this means we can't use any state or hooks here.

	//  nest all the registered masters. Only only can be for layout otherwise weird stuff will happen
	const TopMaster = ({ children }: IChildrenProps) =>
		masters.reverse().reduce((prev, Master) => <Master children={prev}></Master>, <>{children}</>);

	return (
		<TopMaster>
			<CorePage />
		</TopMaster>
	);
}
